<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" style="display: flex;">
        <a-form-item label="水司">
          <a-select placeholder="请选择" style="width: 210px" v-model="query.tenantId" allow-clear>
            <a-select-option
              v-for="item in tenantList"
              :key="item.tenantId"
              :value="item.tenantId"
            >{{ item.tenantName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="文件名称" style="margin-left: 20px">
          <a-input
            style="width: 210px"
            v-model="query.fileName"
            placeholder="请输入文件名称"
            allow-clear
          />
        </a-form-item>
        <a-form-item style="margin-left: 20px">
          <a-button type="primary" @click="queryList">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
          <a-button type="primary" style="margin-left: 8px" @click="handleUpload()">上传</a-button>
          <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag :color="text === 1 ? 'rgb(50, 205, 50)' : 'orange'" slot="storeType" slot-scope="text">{{ text | storeTypeFilter }}</a-tag>
      <a-tag slot="preview" slot-scope="text">
        <img v-if="text.concat('image')" :src="text" style="width: 40px;height: 40px">
        <span v-else>不支持</span>
      </a-tag>
      <span slot="action" slot-scope="text, record">
        <a :href="record.url" target="_blank">下载</a>
      </span>
    </a-table>
    <a-modal
      title="文件上传"
      style="top: 20px"
      :width="800"
      v-model="uploadVisible"
      @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="log-form" :form="detailForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="选择文件">
          <a-upload-dragger
            name="file"
            :multiple="true"
            :headers="headers"
            :action="uploadUrl"
            @change="handleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或拖拽文件到此区域进行上传
            </p>
            <p class="ant-upload-hint">
              支持单次或批量上传。严禁上传公司资料或其他私密文件
            </p>
          </a-upload-dragger>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const STORE_TYPE = {
  1: '阿里云存储',
  2: '本地存储'
}

const columns = [
  {
    title: '文件名称',
    dataIndex: 'fileName'
  },
  {
    title: '文件类型',
    dataIndex: 'mimeType',
    ellipsis: true
  },
  {
    title: '文件大小',
    dataIndex: 'fileSize'
  },
  {
    title: '访问地址',
    dataIndex: 'url',
    ellipsis: true
  },
  {
    title: '预览',
    dataIndex: 'url',
    scopedSlots: { customRender: 'preview' }
  },
  {
    title: 'MD5',
    dataIndex: 'md5',
    ellipsis: true
  },
  {
    title: '存储方式',
    dataIndex: 'storeType',
    scopedSlots: { customRender: 'storeType' }
  },
  {
    title: '水司ID',
    dataIndex: 'tenantId'
  },
  {
    title: '应用',
    dataIndex: 'appName'
  },
  {
    title: '上传时间',
    dataIndex: 'createTime'
  }, {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      queryUrl: '/manager/file/resources/page',
      deleteUrl: '/manager/file/resources',
      uploadUrl: `${process.env.VUE_APP_API_BASE_URL}manager/file/resources/upload`, // 上传文件URL
      headers: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
      query: {
        fileName: '',
        status: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      uploadVisible: false, // 详情窗口是否可见
      detailForm: {}
    }
  },
  filters: {
    storeTypeFilter (key) {
      return STORE_TYPE[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.getAllTenant()
  },
  methods: {
    handleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.code === 0) {
          this.$message.success(`${info.file.name} 文件上传成功.`)
          this.queryList()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
      }
    },
    handleUpload () {
      this.uploadVisible = true
    },
    detailInfo (record) {
      this.detailForm = { ...record }
      this.uploadVisible = true
    },
    handleOk () {
      this.uploadVisible = false
    },
    handleCancel () {
      this.uploadVisible = false
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
